import React, { useState } from "react";
import SingleAddressDetail from "./SingleAddressDetail";
import NoAddressFound from "../../assets/svg/NoAddressFound";
import useAuth from "../../hooks/useAuth";
import AddAddressForm from "./AddAddressForm";
import EditAddressForm from "./EditAddressForm";

const AddressDetailContainer = ({ onClose }) => {
  const { user } = useAuth();
  const [mode, setMode] = useState("list");
  const [selectedAddress, setSelectedAddress] = useState(null);

  const changeMode = () => {
    setMode("list");
    setSelectedAddress(null);
  };

  const handleEditClick = (address) => {
    setSelectedAddress(address);
    setMode("edit");
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-auto p-4">
        {mode === "list" && (
          <div className="bg-[#FFFFFF80] p-4 rounded-lg shadow-sm border-[#00000010] border space-y-3">
            <p className="text-[14px] leading-5 mb-4 general-sans-medium text-gray-700">
              Including addresses related to{" "}
              <span className="supreme-bold text-[15px] text-gray-700">
                +91 {user?.phone?.slice(3)}
              </span>{" "}
              where we previously delivered orders.
            </p>
            {user?.addresses?.map((address) => {
              return (
                <SingleAddressDetail
                  mt="mt-3"
                  address={address}
                  key={address?.id}
                  onClose={onClose}
                  onEdit={() => handleEditClick(address)}
                />
              );
            })}
          </div>
        )}
        {mode === "add" && (
          <AddAddressForm
            showCancel={true}
            cancelAdd={changeMode}
            onClose={onClose}
          />
        )}

        {mode === "edit" && selectedAddress && (
          <EditAddressForm
            address={selectedAddress}
            showCancel={true}
            cancelEdit={changeMode}
            onClose={onClose}
          />
        )}
      </div>

      {mode === "list" && (
        <div className="sticky bottom-0 bg-white p-4">
          <button
            className="w-full bg-black text-white p-4 rounded-lg"
            onClick={() => setMode("add")}
          >
            Add New Address
          </button>
        </div>
      )}
    </div>
  );
};

export default AddressDetailContainer;
